<script setup>
import {defineModel, defineProps} from 'vue'
import {isFacebookUrl, openUrl, removeObjectFromArray} from '@shared/utils/helpers'

const modelValue = defineModel({required: true})

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: 'https://www.facebook.com/...',
  },
  hint: {
    type: String,
    default: '',
  },
  invalidMessage: {
    type: String,
    default: 'Enter a valid Facebook link (facebook.com)',
  },
})

const addItem = () => {
  if (props.readonly) {
    return
  }

  modelValue.value.push('')
}

const removeItem = index => {
  removeObjectFromArray(index, modelValue.value)
}

const openLink = url => {
  openUrl(url)
}

const validateInput = event => {
  const input = event.target
  const isValid = !input.value || isFacebookUrl(input.value)

  input.setCustomValidity(isValid ? '' : props.invalidMessage)
}
</script>

<template>
  <div @keydown.enter.prevent="addItem">
    <div v-for="(url, index) in modelValue" :key="`${props.id}-${index}`" class="row gap-1 mb-1 input-height">
      <div class="col pe-0">
        <div class="input-group">
          <input
            v-model="modelValue[index]"
            class="form-control"
            :id="`${props.id}-${index}`"
            type="url"
            :placeholder="props.placeholder"
            :readonly="props.readonly"
            :required="props.required"
            @input="validateInput"
          />
          <span v-if="url" class="input-group-text gap-2">
            <span class="open-in-new-tab-btn clickable-icon" @click="openLink(url)" v-tooltip="'Open in a new tab'">
              <i class="fa-solid fa-link" />
            </span>
          </span>
        </div>
      </div>
      <div v-if="modelValue.length > 1 && !props.readonly" class="col-auto px-0 input-height">
        <button class="form-icon-btn h-100" @click="removeItem(index)" type="button">
          <i class="fa fa-trash pointer"></i>
        </button>
      </div>
      <div v-if="!props.readonly" class="col-auto pl-0 input-height">
        <div class="w-30-px h-100">
          <button
            v-if="modelValue.length === index + 1"
            @click="addItem"
            class="form-icon-btn d-block h-100"
            type="button"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="props.hint && !props.readonly" class="small text-muted">
      <small>{{ props.hint }}</small>
    </div>
  </div>
</template>
